module.exports = __webpack_public_path__ + "static/img/rank_logo_gold.61470005.png";